import { Label } from "../label";

type Props = {
  name: string;
  type: string;
  label: string;
  value?: string;
  defaultValue?: string;
  placeholder?: string;
  register?: any;
  header?: boolean;
  required?: boolean;
};

export default function TextField({
  name,
  type,
  label,
  value,
  defaultValue,
  placeholder,
  register = {},
  header = true,
  required,
}: Props) {
  const handleOnChange = (e: any) => {};

  return (
    <div>
      {header && <Label name={name} label={label} required={required} />}
      <div className="mt-2">
        <input
          onChange={handleOnChange}
          defaultValue={defaultValue}
          type={type}
          name={name}
          id={name}
          value={value}
          placeholder={placeholder}
          className="block w-full rounded-md border border-gray-300 py-2 px-3 font-input text-input shadow-sm focus:border-indigo-500 focus:outline-none focus:ring-indigo-500"
          {...register}
        />
      </div>
    </div>
  );
}
